import { API_BASE_URL } from "./agreementConfig";

export async function fetchAgreementInfo(type) {
  const response = await fetch(`${API_BASE_URL}/api/front/agreement/${type}`, {
    headers: {
      "content-type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`协议接口请求失败: ${response.status}`);
  }

  const result = await response.json();

  if (result.code !== 200 || !result.data) {
    throw new Error(result.message || "协议内容为空");
  }

  const parsed = JSON.parse(result.data);
  return parsed.agreement || "";
}
